import { safeVoiceStatus } from './safeVoiceStatus'

export const initialVoiceState = () => ({
  runId: '', attemptId: '', sequence: -1, answerStarted: false, status: '', terminal: false,
})

const ctx = (event, state) => ({
  run_id: event.run_id ?? state.runId,
  attempt_id: event.attempt_id ?? state.attemptId,
  sequence: event.sequence ?? state.sequence,
})
const result = (state, commands = [], timings = [], watch = '', context = {}) =>
  ({ state, commands, timings, watch, context })

export function voiceTransition(state, event) {
  const next = ctx(event, state)
  if (event.type === 'client_timing') return result(state, [{ type: 'timing', name: event.name, timestamp_ms: event.timestamp_ms, ...next }], [event])
  if (event.type === 'stream_settled') {
    const commands = state.terminal ? [] : [{ type: 'playback', action: 'stop', ...next }]
    return result(state.terminal ? state : initialVoiceState(), commands, [], 'stop')
  }
  if (event.type === 'start' || event.type === 'restart') {
    const action = event.type === 'start' ? 'stop' : 'restart'
    return result({ ...initialVoiceState(), runId: next.run_id, attemptId: next.attempt_id, sequence: next.sequence }, [{ type: 'playback', action, ...next }], [], 'stop')
  }
  if (event.type === 'error') return result({ ...state, terminal: true }, [{ type: 'error', ...next }], [], 'stop')
  if (event.type === 'chunk' && event.text) {
    const changed = state.answerStarted && (next.run_id !== state.runId || next.attempt_id !== state.attemptId)
    const timing = { type: 'timing', name: 'first_answer_chunk', timestamp_ms: Date.now(), ...next }
    const commands = changed ? [{ type: 'playback', action: 'restart', ...next }] : []
    if (!state.answerStarted || changed) commands.push({ type: 'timing', ...timing })
    commands.push({ type: 'narration', lane: 'answer', text: event.text, ...next })
    return result({ ...state, runId: next.run_id, attemptId: next.attempt_id, sequence: next.sequence, answerStarted: true }, commands, !state.answerStarted || changed ? [timing] : [], 'stop')
  }
  if (event.type === 'done') return result({ ...state, terminal: true, sequence: next.sequence }, [{ type: 'narration', lane: 'answer', final: true, ...next }], [], 'stop')
  const status = safeVoiceStatus(event)
  if (!status && event.type === 'tool_result' && event.tool === 'work_status') {
    return result({ ...state, status: '' }, [], [], 'stop')
  }
  if (!status || state.answerStarted || status === state.status) return result(state)
  const command = { type: 'narration', lane: 'status', text: status, segment_id: `status:${next.sequence}`, ...next }
  return result({ ...state, runId: next.run_id, attemptId: next.attempt_id, sequence: next.sequence, status }, [command], [], 'active', next)
}
